import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DivingIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DivingIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M4.3443 2V9.03161H2.02192V2H4.3443Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.6845 16.0139C15.2824 16.0193 16.5861 17.3335 16.5779 18.9305C16.5696 20.5286 15.2531 21.8305 13.6568 21.8193C12.0661 21.8081 10.7706 20.5022 10.7731 18.9125C10.7757 17.3147 12.0876 16.0085 13.6845 16.0139ZM13.1071 18.3396V19.4834H14.2405V18.3396H13.1071Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.8163 20.0598C9.55742 19.3005 9.56223 18.5393 9.82227 17.7476H9.22989C8.86862 17.7476 8.54615 17.7609 8.22507 17.7453C6.46712 17.6604 4.93875 16.4165 4.48369 14.7238C4.32699 14.141 4.34605 13.5496 4.34435 12.9573C4.34395 12.8181 4.34429 12.6789 4.34429 12.5293H2.03174C1.61028 17.6659 5.45899 20.391 9.22392 20.0598L9.8163 20.0598Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.33314 11.3588H2.0365V10.2193H4.33314V11.3588Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.22382 12.513C9.49128 12.5218 9.75769 12.5211 10.0255 12.513H9.22382Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.6516 7.95064C21.1607 6.54561 19.9341 5.6534 18.4447 5.57796C18.4077 5.6136 8.67194 5.58528 8.55592 5.59969C6.87831 5.80928 5.56544 7.24837 5.50874 8.93563C5.45234 10.6169 6.67006 12.1701 8.34163 12.4419C8.53383 12.4731 8.73152 12.4758 8.92726 12.4891C9.06148 12.3542 11.1942 10.2044 13.6748 10.2044C16.2167 10.2044 18.406 12.4743 18.4447 12.5097V12.5122C18.4818 12.5095 18.5197 12.5118 18.5567 12.5086C20.0214 12.385 21.0529 11.617 21.6093 10.2479C21.7195 9.97665 21.7645 9.67916 21.8396 9.39364V8.69686C21.7779 8.44771 21.7359 8.19186 21.6516 7.95064Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.2194 12.513C17.6191 12.5372 18.0194 12.5407 18.4167 12.513H17.2194Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.90626 12.5165V12.5131L18.4447 12.5122V12.5165C18.4078 12.5518 16.2167 14.8217 13.6763 14.8217C11.1343 14.8217 8.94502 12.5519 8.90626 12.5165Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DivingIcon;
